var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvalopGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 3.11482V11.5148C17.1667 11.9922 16.9722 12.45 16.6259 12.7876C16.2797 13.1252 15.8101 13.3148 15.3205 13.3148H3.01281C2.52318 13.3148 2.0536 13.1252 1.70738 12.7876C1.36116 12.45 1.16666 11.9922 1.16666 11.5148V3.11482M17.1667 3.11482C17.1667 2.63743 16.9722 2.17959 16.6259 1.84203C16.2797 1.50446 15.8101 1.31482 15.3205 1.31482H3.01281C2.52318 1.31482 2.0536 1.50446 1.70738 1.84203C1.36116 2.17959 1.16666 2.63743 1.16666 3.11482M17.1667 3.11482V3.30922C17.1667 3.61654 17.086 3.91874 16.9323 4.18706C16.7787 4.45537 16.5571 4.68085 16.2887 4.84202L10.1349 8.53402C9.84375 8.70885 9.50856 8.80142 9.16666 8.80142C8.82475 8.80142 8.48956 8.70885 8.19845 8.53402L2.04461 4.84282C1.77623 4.68165 1.55465 4.45617 1.40097 4.18786C1.24729 3.91954 1.16662 3.61734 1.16666 3.31002V3.11482",
    stroke: "#00848D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvalopGreen);
export default __webpack_public_path__ + "static/media/envalopGreen.fc4e3b9228213c8b77dcddebf17537de.svg";
export { ForwardRef as ReactComponent };